import {
  Box,
  Card,
  CardContent,
  Paper,
  FormControl,
  Stack,
  Typography,
  Divider,
  CardMedia,
  Button,
  InputAdornment,
  TextField,
  CircularProgress,
} from "@mui/material";

import { Grid, Select, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { theme } from "@/components/Elements/theme";
import cryptoPayments from "@/assets/cryptoPayments.svg";
import axios from "axios";
import storage from "@/utils/storage";
import Swal from "sweetalert2";
import VerifyWithdrawOTP1 from "@/components/Modals/verifyWithdrawOTP";


interface CoinRateItem {
  Id: number;
  Symbol: string;
  Name: string;
}
interface FormValues {
  amount: number;
  cryptoType: StableCoin | string;
  walletAddress: string;
  // paymentMethodId: string;
}

interface FormErrors {
  amount?: string;
  cryptoType?: string;
  walletAddress?: string;
}

interface ErrorState {
  cryptoType?: any;
  amount?: any;
  walletAddress?: any;
}
interface StableCoin {
  Id: number;
  Symbol: string;
  Name: string;
  image: string;
  contractAddress: string;
  network: string;
}
export const WithDraw = () => {
  const [totalWalletBal, setTotalWalletBal] = useState(0);
  const [winArray, setWinArray] = useState([
    {
      LotteryName: "",
      amount: "",
      lotteryStatus: "",
      transactionId: "",
      winAmount: "",
    },
  ]);
  const [loading, setLoading] = useState(false);




  const [convertedRate, setConvertedRate] = useState("");
  const [loadingCurrency, setLoadingCurrency] = useState(false);
  const [stableCoins, setStableCoins] = useState<StableCoin[]>([]);

  useEffect(() => {
    setStableCoins(getStableCoins());
  }, []);



  const [formValues, setFormValues] = useState<FormValues>({
    amount: 0,
    cryptoType: "select",
    walletAddress: "",
    // paymentMethodId: "",
  });

  console.log("formValues", formValues);

  const [userData, setUserData] = useState({
    userId: "",
    emailId: "",
  });
  useEffect(() => {
    getUserData();
  }, []);
  const getUserData = async () => {
    let token = storage.getToken();
    const response = await axios.get(
      `${process.env.API_URL_PREFIX}/api/v1/user/userdetail`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
      }
    );
    setUserData({
      userId: response?.data?.data?._id,
      emailId: response?.data?.data?.email,
    });
  };



  const Item = styled(Paper)(({ theme }) => ({
    background: "transparent",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  }));

  var cardStyle = {
    display: "block",
    transitionDuration: "0.3s",
    background: "#050518",
    boxShadow: "0px 4px 50px 30px rgba(181, 181, 181, 0.05)",
    borderRadius: "20px",
  };

  var center = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  var content = {
    color: "#ffff",
    backgroundColor: "#050518",
    borderRadius: "12px",
  };
  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    let token = storage.getToken();

    const response = await axios.get(
      `${process.env.API_URL_PREFIX}/api/v1/user/fetchUserWalletBalance`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
      }
    );
    const data = response.data.data.walletAmount;
    setTotalWalletBal(data);
    setWinArray(data.myLotteryArrray);
    setLoading(true);
  };





  const [isOpen, setIsopen] = useState(false);
  const [error, setError] = useState<ErrorState>({});
  const [isValid, setIsValid] = useState<boolean | null>(null);

  const validateAmount = (amount) => {
    if (amount <= 5.99) {
      return "Amount should be greater than 5.99";
    }
    return "";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "cryptoType") {
      // Find the complete stableCoin object based on the selected value
      const selectedCoin = stableCoins.find(coin => coin.Symbol === value);
      
      setFormValues({
        ...formValues,
        cryptoType: selectedCoin || value, // Store the complete object or fallback to value
      });
    } else {
      setFormValues({
        ...formValues,
        [name]: value,
      });
    }

    // Handle amount validation
    if (name === "amount") {
      const amount = parseFloat(value);
      if (isNaN(amount) || amount <= 5.99) {
        setError(prev => ({
          ...prev,
          amount: (
            <span style={{ fontSize: "12px", color: "red" }}>
              Amount should be greater than 5.99
            </span>
          ),
        }));
      } else {
        setError(prev => ({ ...prev, amount: "" }));
      }
    }
  };
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const isValid = checkValidation("all"); // Validate all fields

    if (!isValid) {
      console.log("Form is invalid. Check errors.");
      setLoading(false); // Ensure loading state is off if form is invalid
      return; // Prevent further code execution if form is invalid
    }

    try {
      console.log("Form is valid. Proceed with withdrawal request.");
      setIsopen(true); // Open OTP verification modal
      setLoading(true); // Set loading state before API request

      let token = storage.getToken();
      const res = await axios.post(
        `${process.env.API_URL_PREFIX}/api/v1/user/extWalletWithdrawReqOTP`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );

      // Handle success if needed here
    } catch (error) {
      setLoading(false); // Stop loading if an error occurs
      Swal.fire({
        background: "black",
        color: "#ffff",
        text: "An error occurred",
      }).then(() => {
        window.location.reload();
      });
    }
  };

  const handleClose = () => {
    setIsopen(false);
  };

  const checkValidation = (type) => {
    let isFormValid = true;
    let newError = { ...error }; // Copy existing errors

    // Validate cryptoType
    if (type === "cryptoType" || type === "all") {
      if (!formValues?.cryptoType || 
          (typeof formValues?.cryptoType === "string" && formValues?.cryptoType === "select")) {
        newError.cryptoType = (
          <span style={{ fontSize: "12px", color: "red" }}>
            Please select a cryptocurrency
          </span>
        );

        isFormValid = false;
      } else {
        newError.cryptoType = ""; // Clear error if valid
      }
    }

    // Validate amount
    if (type === "amount" || type === "all") {
      const amount =
        typeof formValues?.amount === "string"
          ? parseFloat(formValues?.amount)
          : formValues?.amount;

      if (isNaN(amount) || amount <= 5.99) {
        newError.amount = (
          <span style={{ fontSize: "12px", color: "red" }}>
            Amount should be greater than 5.99
          </span>
        );
        isFormValid = false;
      } else {
        newError.amount = ""; // Clear error if valid
      }
    }

    // Validate walletAddress
    if (type === "walletAddress" || type === "all") {
      if (!formValues?.walletAddress) {
        newError.walletAddress = (
          <span style={{ fontSize: "12px", color: "red" }}>
            Please select a cryptocurrency
          </span>
        );
        isFormValid = false;
      } else {
        newError.walletAddress = ""; // Clear error if valid
      }
    }

    setError(newError);
    return isFormValid;
  };

  const handleBlur = () => {
    checkValidation("cryptoType");
  };

  const validateWalletAddressForPayment = async (walletAddress) => {
    try {
      const network = typeof formValues.cryptoType === "object" 
        ? formValues.cryptoType.network 
        : formValues.cryptoType;
        
      const response = await axios.post(
        `${process.env.API_URL_PREFIX}/api/v1/user/isValidAddressForPayment`,
        {
          address: walletAddress,
          network: network,
        }
      );
      if (response.data.isValid) {
        setIsValid(true);
        setError((prev) => ({ ...prev, walletAddress: "" }));
      } else {
        setIsValid(false);
        setError((prev) => ({
          ...prev,
          walletAddress: "Invalid wallet address",
        }));
      }
    } catch (error) {
      console.error("API error:", error);
      setIsValid(false);
      setError((prev) => ({ ...prev, walletAddress: "Validation failed" }));
    }
  };
  useEffect(() => {
    if (formValues.walletAddress) {
      validateWalletAddressForPayment(formValues.walletAddress);
    }
  }, [formValues.walletAddress]); // This runs whenever walletAddress changes

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedAddress = e.clipboardData.getData("Text"); // Get the pasted value
    setFormValues((prev) => ({ ...prev, walletAddress: pastedAddress })); // Update state
    validateWalletAddressForPayment(pastedAddress); // Call the validation API
  };

  const getStableCoins = (): StableCoin[] => {
    return [
      {
        Id: 1,
        Symbol: "USDC Ethereum",
        Name: "USD Coin",
        image: "https://nowpayments.io/images/coins/usdc.svg",
        contractAddress: "0xa0b86991c431e7bebe8d7cdc6c7c5b73b",
        network: "ethereum"
      },
      {
        Id: 2,
        Symbol: "DAI Ethereum",
        Name: "Dai Stablecoin",
        image: "https://nowpayments.io/images/coins/dai.svg",
        contractAddress: "0x6b175474e89094c44da98b954eedeac495271d0f",
        network: "ethereum"
      },
      {
        Id: 3,
        Symbol: "USDT Ethereum",
        Name: "Tether USD",
        image: "https://nowpayments.io/images/coins/usdt.svg",
        contractAddress: "0xdac17f958d2ee523a2206206994597c13d831ec7",
        network: "ethereum"
      }
    ];
  };

  return (
    <Box sx={{ height: "auto", marginTop: "10px" }}>
      <form onSubmit={handleFormSubmit}>
        {/* <form> */}
        <Grid container spacing={{ xs: 1, md: 1.5, lg: 3 }}>
          <Grid item xs={6} md={6}>
            {" "}
            <Card
              style={cardStyle}
              sx={{
                p: { md: theme.spacing(0.3), xs: theme.spacing(0.1) },
                height: "100% !important",
                boxSizing: "border-box",
              }}
            >
              <CardContent
                sx={{ p: { md: theme.spacing(0.2), xs: theme.spacing(0.1) } }}
              >
                <Stack spacing={{ xs: "10px", md: "15px" }}>
                  <Item>
                    {" "}
                    <Typography
                      variant="h5"
                      sx={{
                        fontSize: {
                          md: "20px !important",
                          sm: "15px !important",
                          xs: "14px !important",
                        },
                      }}
                    >
                      Withdraw
                    </Typography>
                  </Item>
                  <Item
                    sx={{
                      mt: {
                        xs: "0 !important",
                        md: "10px !important",
                        lg: "16px !important",
                      },
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{ color: "#7E7E7E", textTransform: "uppercase" }}
                    >
                      Select Payment System
                    </Typography>
                  </Item>
                  <Divider
                    sx={{ border: "1px solid rgba(255, 255, 255, 0.2)" }}
                  />
                  <Item className="Select-Payment-System">
                    <Card
                      style={content}
                      sx={{
                        background: "rgba(255, 255, 255, 0.03) !important",
                        display: "flex !important",
                        flexFlow: "row nowrap",
                        width: "100%",
                        textAlign: "start ! important",
                      }}
                      className={"activePayment"}
                    >
                      <CardMedia
                        component="img"
                        sx={{
                          borderRadius: "10px",
                          p: {
                            md: theme.spacing(0.3),
                            xs: theme.spacing(0.2),
                          },
                          width: { md: "150.06px", xs: "80px" },
                          height: { md: "129.68px", xs: "80px" },
                        }}
                        image={cryptoPayments}
                        alt="Live from space album cover"
                      />
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <CardContent
                          sx={{
                            flex: "1 0 auto",
                            p: "0 !important",
                            my: { xs: "10px", md: "15px" },
                          }}
                        >
                          <Stack
                            spacing={{ xs: "10px", md: "15px" }}
                            flex="1 0 1"
                          >
                            <Box>
                              <Typography component="h6" variant="h6">
                                Crypto Payment
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                mt: {
                                  xs: "5px !important",
                                  md: "15px !important",
                                },
                              }}
                            >
                              <Typography
                                component="h3"
                                variant="h3"
                                sx={{
                                  color: "#A3A9AD",
                                  fontSize: { xs: "10px", md: "14px" },
                                }}
                              >
                                Minimum - 5(USD) | Maximum - 1,000,000(USD)
                              </Typography>
                            </Box>

                            <Box
                              sx={{
                                mt: {
                                  xs: "10px !important",
                                  md: "15px !important",
                                },
                              }}
                            >
                              <Button
                                sx={{
                                  padding: {
                                    xs: "6px 10px",
                                    lg: "7.73px 19px",
                                  },
                                  fontSize: { xs: "12px", md: "14px" },
                                  backgroundColor: "rgba(60, 55, 255, 0.15)",
                                  color: "#3C37FF",
                                  borderRadius: "19px",
                                }}
                              >
                                Payments.Commision - 0
                              </Button>
                            </Box>
                          </Stack>
                        </CardContent>
                      </Box>
                    </Card>
                  </Item>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6} md={6}>
            {" "}
            <Card
              style={cardStyle}
              sx={{
                p: { md: theme.spacing(0.3), xs: theme.spacing(0.1) },
                height: "100% !important",
                boxSizing: "border-box",
              }}
            >
              <CardContent
                sx={{ p: { md: theme.spacing(0.2), xs: theme.spacing(0.1) } }}
              >
                <Stack spacing={{ xs: "10px", md: "15px" }}>
                  <Item sx={{ display: "contents" }}>
                    {" "}
                    <Typography
                      variant="h5"
                      sx={{
                        fontSize: {
                          md: "20px !important",
                          sm: "15px !important",
                          xs: "14px !important",
                        },
                      }}
                    >
                      Select Withdrawal Amount
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{ color: "#7E7E7E", textTransform: "uppercase" }}
                    >
                      Enter details to proceed
                    </Typography>
                  </Item>
                  <Divider
                    sx={{ border: "1px solid rgba(255, 255, 255, 0.2)" }}
                  />
                  <Item>
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        p: { lg: 1, xs: "6px" },
                        bgcolor: "transparent",
                        border: "0.5px solid rgba(255, 255, 255, 0.2)",
                        borderRadius: "10px",
                        opacity: 0.6,
                        width: "100%",
                      }}
                    >
                      <Box
                        sx={{ p: { md: "15px", xs: "3px 6px" }, flex: "30%" }}
                      >
                        <Typography component="h6" variant="h6">
                          Total Available
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          p: { md: "15px", xs: "3px 6px" },
                          flex: "30%",
                          textAlign: "right",
                        }}
                      >
                        <Typography component="h6" variant="h6">
                          $ {totalWalletBal}
                        </Typography>
                      </Box>
                      <Box
                        sx={{ p: { md: "15px", xs: "3px 6px" }, flex: "100%" }}
                      >
                        <Divider
                          orientation="horizontal"
                          flexItem
                          sx={{
                            border: "1px solid rgba(255, 255, 255, 0.2)",
                          }}
                        />
                      </Box>
                    </Box>
                  </Item>

                  <Typography
                    variant="h6"
                    sx={{
                      display: "block",
                      mt: { xs: "8px !important", lg: 2 },
                    }}
                  >
                    Select Crypto-Currency
                  </Typography>
                  <FormControl
                    sx={{
                      mt: { xs: "8px !important", lg: 1 },
                      minWidth: 120,
                      width: "100%",
                    }}
                  >
                    <Select
                      sx={{
                        width: "100%",
                        "& .MuiSelect-select": {
                          padding: { xs: "12px 10px", lg: "16px 16px" },
                        },
                      }}
                      labelId="demo-controlled-open-select-label"
                      id="demo-controlled-open-select"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      value={typeof formValues?.cryptoType === "object" ? formValues?.cryptoType?.Symbol : (formValues?.cryptoType || "select")}
                      name="cryptoType"
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            bgcolor: "black",
                            "& .MuiMenuItem-root": {
                              padding: 1,
                              fontFamily: "Ubuntu",
                              fontStyle: "normal",
                              fontWeight: 400,
                              fontSize: "14px",
                            },
                          },
                        },
                      }}
                    >
                      <MenuItem disabled value="select">
                        <em>Select</em>
                      </MenuItem>
                     {stableCoins.map((stableCoin) => {
                      console.log("stableCoin", stableCoin.image);
                      return (
                          <MenuItem
                            key={`stable-${stableCoin.Id}`}
                            value={stableCoin.Symbol}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              backgroundColor: 'rgba(60, 55, 255, 0.05)',
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                                width: "100%",
                              }}
                            >
                              <Box
                                component="img"
                                src={stableCoin.image}
                                alt={stableCoin.Name}
                                onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                                  e.currentTarget.src = 'https://cdn.jsdelivr.net/gh/atomiclabs/cryptocurrency-icons@master/128/color/generic.png';
                                }}
                                sx={{
                                  width: 24,
                                  height: 24,
                                  objectFit: 'contain'
                                }}
                              />
                              <Typography textAlign="left" sx={{ fontSize: "16px" }}>
                                {stableCoin.Name} ({stableCoin.Symbol})
                              </Typography>
                             
                            </Box>
                          </MenuItem>
                      );
                     })}
                    </Select>
                    {error?.cryptoType && (
                      <Typography sx={{ color: "red" }}>
                        {error.cryptoType}
                      </Typography>
                    )}
                  </FormControl>


                  <Typography
                    variant="h6"
                    sx={{
                      display: "block",
                      mt: { xs: "8px !important", lg: 2 },
                    }}
                  >
                    Amount
                  </Typography>

                  <FormControl sx={{ flex: 1, mr: 1 }}>
                    <TextField
                      id="outlined-multiline-flexible"
                      type="number"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          width: "100%",
                        },
                        "& .MuiOutlinedInput-input": {
                          textAlign: "left !important",
                          padding: {
                            xs: "12px 10px !important",
                            lg: "16px 14px !important",
                          },
                        },
                      }}
                      inputProps={{
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        min: "1",
                        step: "1",
                      }}
                      placeholder="Enter Withdrawal Amount"
                      maxRows={4}
                      value={formValues?.amount || ""}
                      name="amount"
                      onChange={handleChange}

                    />
                    {error?.amount && (
                      <Typography sx={{ color: "red" }}>
                        {error.amount}
                      </Typography>
                    )}
                  </FormControl>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mx: { xs: 0, lg: 2 },
                    }}
                  >

                  </Box>



                  <Typography
                    variant="h6"
                    sx={{
                      display: "block",
                      mt: { xs: "8px !important", lg: 2 },
                    }}
                  >
                    External Wallet Address
                  </Typography>
                  <FormControl
                    sx={{
                      mt: { xs: "8px !important", lg: 1 },
                      minWidth: 120,
                      width: "100%",
                    }}
                  >
                    <TextField
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          width: "100%",
                          padding: {
                            xs: "12px 10px !important",
                            lg: "16px 14px !important",
                          },
                        },
                      }}
                      id="outlined-multiline-flexible"
                      placeholder="Enter External Wallet Address"
                      multiline
                      maxRows={4}
                      // InputProps={{
                      //   endAdornment: (
                      //     <InputAdornment position="end">
                      //       <PermIdentityIcon style={{ color: "white" }} />
                      //     </InputAdornment>
                      //   ),
                      // }}
                      value={formValues?.walletAddress}
                      name="walletAddress"
                      onChange={handleChange}
                      onPaste={handlePaste}
                    />
                    {error?.walletAddress && (
                      <Typography sx={{ color: "red" }}>
                        {error.walletAddress}
                      </Typography>
                    )}
                    {isValid === false && (
                      <Typography sx={{ color: "red" }}>
                        Wallet address is invalid
                      </Typography>
                    )}
                  </FormControl>

                  <Item sx={{ pb: "0px" }}>
                    <Button
                      fullWidth
                      variant="contained"
                      sx={{
                        marginTop: {
                          xs: "10px !important",
                          lg: "20px !important",
                        },
                      }}
                      type="submit"
                    >
                      Withdraw Request
                    </Button>
                  </Item>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <VerifyWithdrawOTP1
          open={isOpen}
          onClose={() => setIsopen(false)}
          formValues={formValues}
          userData={userData}
        />
      </form>
    </Box>
  );
};
